__turbopack_export_value__({
  "active": "navbar-module-scss-module__cl-5Ba__active",
  "bar": "navbar-module-scss-module__cl-5Ba__bar",
  "body-logo-18": "navbar-module-scss-module__cl-5Ba__body-logo-18",
  "body-text-12": "navbar-module-scss-module__cl-5Ba__body-text-12",
  "body-text-14": "navbar-module-scss-module__cl-5Ba__body-text-14",
  "body-text-16": "navbar-module-scss-module__cl-5Ba__body-text-16",
  "body-text-18": "navbar-module-scss-module__cl-5Ba__body-text-18",
  "body-text-20": "navbar-module-scss-module__cl-5Ba__body-text-20",
  "body-text-24": "navbar-module-scss-module__cl-5Ba__body-text-24",
  "body-text-24-2": "navbar-module-scss-module__cl-5Ba__body-text-24-2",
  "body-text-heading-2": "navbar-module-scss-module__cl-5Ba__body-text-heading-2",
  "body-text-heading-3": "navbar-module-scss-module__cl-5Ba__body-text-heading-3",
  "body-text-medium-14": "navbar-module-scss-module__cl-5Ba__body-text-medium-14",
  "body-text-medium-16": "navbar-module-scss-module__cl-5Ba__body-text-medium-16",
  "body-text-medium-18": "navbar-module-scss-module__cl-5Ba__body-text-medium-18",
  "body-text-medium2-18": "navbar-module-scss-module__cl-5Ba__body-text-medium2-18",
  "body-text2-14": "navbar-module-scss-module__cl-5Ba__body-text2-14",
  "body-text2-16": "navbar-module-scss-module__cl-5Ba__body-text2-16",
  "button-primary-text": "navbar-module-scss-module__cl-5Ba__button-primary-text",
  "button-text": "navbar-module-scss-module__cl-5Ba__button-text",
  "button2-text": "navbar-module-scss-module__cl-5Ba__button2-text",
  "card-shadow": "navbar-module-scss-module__cl-5Ba__card-shadow",
  "effect-menu": "navbar-module-scss-module__cl-5Ba__effect-menu",
  "footer": "navbar-module-scss-module__cl-5Ba__footer",
  "header-1": "navbar-module-scss-module__cl-5Ba__header-1",
  "hidden": "navbar-module-scss-module__cl-5Ba__hidden",
  "link": "navbar-module-scss-module__cl-5Ba__link",
  "list": "navbar-module-scss-module__cl-5Ba__list",
  "listItem": "navbar-module-scss-module__cl-5Ba__listItem",
  "main-container": "navbar-module-scss-module__cl-5Ba__main-container",
  "main-footer-container": "navbar-module-scss-module__cl-5Ba__main-footer-container",
  "main-header-container": "navbar-module-scss-module__cl-5Ba__main-header-container",
  "specialLink": "navbar-module-scss-module__cl-5Ba__specialLink",
  "tabs": "navbar-module-scss-module__cl-5Ba__tabs",
  "txt-12-bold": "navbar-module-scss-module__cl-5Ba__txt-12-bold",
  "txt-14-bold": "navbar-module-scss-module__cl-5Ba__txt-14-bold",
  "txt-14-bold-caps": "navbar-module-scss-module__cl-5Ba__txt-14-bold-caps",
  "txt-14-med": "navbar-module-scss-module__cl-5Ba__txt-14-med",
  "txt-16-bold": "navbar-module-scss-module__cl-5Ba__txt-16-bold",
  "txt-16-med": "navbar-module-scss-module__cl-5Ba__txt-16-med",
  "txt-18-bold": "navbar-module-scss-module__cl-5Ba__txt-18-bold",
  "txt-18-medium": "navbar-module-scss-module__cl-5Ba__txt-18-medium",
  "txt-18-medium-24": "navbar-module-scss-module__cl-5Ba__txt-18-medium-24",
  "txt-24-semi": "navbar-module-scss-module__cl-5Ba__txt-24-semi",
});
